import React, { Children } from "react";
import { Container, Modal } from "react-bootstrap";

import "./BranchModalWrapper.scss";

const BranchModalWrapper = ({ show, children }) => {
  return (
    <Modal show={show} size="sm" centered>
      <Container fluid>
        <Modal.Body>{children}</Modal.Body>
      </Container>
    </Modal>
  );
};

export default BranchModalWrapper;
